import { VERIFY_CODE_LIMIT_ERR } from 'common/constants/Constants';
import { BLOCKED_ERROR_CODE, BLOCKED_ERROR_MSG, LOGIN_METHOD } from 'idpBase/Constants';

/** 登录数据上报 */
export const DATA_REPORT_REGISTER_TYPE = {
  [LOGIN_METHOD.MOBILE]: {
    register: 'e#phone_login_web#register#click',
    more: 'e#phone_login_web#more_ways#click',
  },
  [LOGIN_METHOD.EMAIL]: {
    register: 'e#mail_first_login_web#register#click',
    more: 'e#mail_first_login_web#more_ways#click',
  },
};

/** 登录企业错误信息 */
export const LOGIN_ACCOUNT_ERROR_MSG = {
  E0010035: '您在当前企业已被停用，请联系管理员', // 在该企业中为停用状态
  E0100024: '开通应用失败',
  [BLOCKED_ERROR_CODE]: BLOCKED_ERROR_MSG[BLOCKED_ERROR_CODE],
};

export const VERIFY_CODE_ERROR = {
  E0010334: '验证失败，请稍后重试',
  E0010061: '手机号已注册，请登录',
  E0010028: '验证码不正确，请重新输入',
  ...VERIFY_CODE_LIMIT_ERR,
};

export enum LOGIN_RES_TYPE {
  /** 登录成功 */
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  /** 进入账号选择 */
  ACCOUNT_OPTIONS = 'ACCOUNT_OPTIONS',
  /** 进入企业创建页面 */
  ACCOUNT_CREATE = 'ACCOUNT_CREATE',
}

/**
 * 登录企业结果类型
 */
export enum LOGIN_TENANT_TYPE {
  /** 成功，除了失败情况都算成功 */
  SUCCESS = 'DUMMY',
  /** 不是企业成员 */
  NOT_MEMBER = 'NOT_MEMBER',
  /** 企业成员已被禁用 */
  USER_DISABLED = 'USER_DISABLED',
}
